import {Nullable} from '@fl/cmsch-fe-library';

/** Redux form name for the criteria-list-details form. */
export const getCriteriaListDetailsFormName = 'getCriteriaListDetails';

/** Form values used by the criteria-list-details form. */
export interface GetCriteriaListDetailsFormValues {
    /** Selected criteria list id. */
    criteriaListId: Nullable<number>;
}
